export const updateQueueManagerToken = (details) => ({
    type: 'UPDATE_QUEUE_MANAGER_TOKEN',
    payload: details
});

export function resetQueueManager() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'RESET_QUEUE_MANAGER'
            });
            resolve(true)
        });
    }
};